import axios from '../utils/request';

// 模块配置
const moduleConfApi = {
  // 获取动漫话题列表
  getDmSections(params) {
    return axios({
      url: '/module/dmSection/list',
      type: 'post',
      params
    })
  },
  // 新增动漫话题
  addDmSection(params) {
    return axios({
      url: '/module/dmSection/add',
      type: 'post',
      params
    })
  },
  // 修改动漫话题
  editDmSection(params) {
    return axios({
      url: '/module/dmSection/edit',
      type: 'post',
      params
    })
  },
  // 删除动漫话题
  deleteDmSection(params) {
    return axios({
      url: '/module/dmSection/delete',
      type: 'post',
      params
    })
  },
  // 查询动漫话题点击量
  queryDmClicks(params) {
    return axios({
      url: '/module/dmSection/clicks',
      type: 'post',
      params
    })
  },

  // 获取动漫话题模块视频列表
  getVideos(params) {
    return axios({
      url: '/module/video/list',
      type: 'post',
      params
    })
  },
  // 新增动漫话题模块视频
  addVideo(params) {
    return axios({
      url: '/module/video/add',
      type: 'post',
      params
    })
  },
  // 批量新增动漫话题模块视频
  addVideos(params) {
    return axios({
      url: '/module/video/add/batch',
      type: 'post',
      params
    })
  },
  // 修改动漫话题模块视频
  editVideo(params) {
    return axios({
      url: '/module/video/edit',
      type: 'post',
      params
    })
  },
  // 删除动漫话题模块视频
  deleteVideo(params) {
    return axios({
      url: '/module/video/delete',
      type: 'post',
      params
    })
  }
}

export default moduleConfApi;